module.exports = __webpack_public_path__ + "img/title-4.7981799e.png";